import axios from 'axios';

import { JWTService } from '@services/jwt.service';

import { removeLastSlashFromUrl } from '@helpers';

const axiosInstanceParams = {
  headers: {
    Authorization: {
      toString() {
        return `bearer ${JWTService.getToken()}`;
      },
    },
  },
};

export const API_URL = removeLastSlashFromUrl(process.env.VUE_APP_API.trim());
export const API_POSTFIX_V1 = '/api/v1/';
export const API_POSTFIX_V2 = '/api/';

export const generateXHRErrorResponse = (e) => {
  const { data } = e.response || {};
  const response = { status: e?.response?.status, msg: '' };

  if (data && typeof data === 'object' && (data.message || data.Error || data.Message)) {
    response.msg = data.message || data.Error || data.Message;
  } else if (data && typeof data !== 'object') {
    response.msg = data;
  } else {
    response.msg = 'Sorry, something went wrong!';
  }

  return response;
};

export const ApiServiceV1 = axios.create({
  baseURL: `${API_URL}${API_POSTFIX_V1}`,
  ...axiosInstanceParams,
});

export const wrapToOldRESTUrl = (suffix, url) => `${API_URL}/${suffix}${API_POSTFIX_V2}${url}`;

// Response resolvers
const resolve = response => response;
const reject = e => Promise.reject(
  axios.isCancel(e)
    ? { isCancel: true, msg: e.message }
    : generateXHRErrorResponse(e),
);

// Configure service instance interceptors
ApiServiceV1.interceptors.response.use(resolve, reject);

export default {
  ApiServiceV1,
  API_URL,
  API_POSTFIX_V1,
  API_POSTFIX_V2,
  wrapToOldRESTUrl,
  generateXHRErrorResponse,
};
